import { PartnerFormDocumentResponse, FormDocumentOptOutRequest } from "@/shared/types";
import bankResource from "@/shared/resource/bank";
import { authorizedAxios } from "@/shared/api/authorizedAxios";


export function addOrUpdateResourceForm (partnerId: number, item) {
    return authorizedAxios.post<number>(bankResource.resourceFormDocumentsByPartnerId(partnerId), item);
}

export function getResourceFormDocumentsByPartnerId (partnerId: number) {
    return authorizedAxios.get<PartnerFormDocumentResponse>(bankResource.resourceFormDocumentsByPartnerId(partnerId));
}
export function putFormDocumentOptInOrOptOut (partnerId: number, request: FormDocumentOptOutRequest) {
    return authorizedAxios.put<void>(bankResource.resourceFormDocumentsByPartnerId(partnerId), request);
}